export default function RadioGroupTail({ notificationMethods, defaultChecked, index, onChange, correctAnswer, submitted, userAnswer, simpleExplanation, citation }) {
  return (
    <div>
      <fieldset className="mt-4">
        <div className="space-y-4">
          {notificationMethods.map((notificationMethod, i) => (
            <div key={notificationMethod.id} className="flex items-start">
              <input
                id={notificationMethod.id}
                name={`notification-method-${index}`}
                type="radio"
                value={notificationMethod.value}
                defaultChecked={notificationMethod.id === defaultChecked}
                className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500 mt-1"
                onChange={onChange}
              />
              <label htmlFor={notificationMethod.id} className="ml-3 block text-sm text-gray-700">
                {notificationMethod.title} 
                {submitted && (i === correctAnswer ? ' ✅' : (userAnswer == i && i !== correctAnswer ? ' ❌' : ''))}
              </label>
              {submitted && i === correctAnswer && userAnswer != i && (
                <div className="ml-4 bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded">
                  {simpleExplanation}
                  <br/><a href={citation} target="_blank" rel="noopener noreferrer">Learn more here</a>
                </div>
              )}
            </div>
          ))}
        </div>
      </fieldset>
    </div>
  );
}
